Ext.define('SA.view.EditableTitle', {
    alias: 'widget.editable-title',
    extend: 'SA.view.EditableText',

    disableNarrowMode() {
        this.removeCls('sa-editable-title-narrower');
    },

    enableNarrowMode() {
        this.addCls('sa-editable-title-narrower');
    },

    getTextWidth() {
        return this.textArea.getWidth();
    },

    resize() {
        var normalScrollHeight;

        this.textArea.setHeight(0);

        this.disableNarrowMode();
        normalScrollHeight = this.textArea.dom.scrollHeight;
        this.enableNarrowMode();

        if (this.textArea.dom.scrollHeight > normalScrollHeight) {
            this.disableNarrowMode();
        }

        this.callParent();
    }
});